import useBrandTranslation from "../hooks/useBrandTranslation";

export default function MercadoPagoPending() {
  const { t } = useBrandTranslation();
  return (
    <main className="flex min-h-screen flex-col items-center justify-center p-4 md:p-24">
      <h1 className="text-2xl font-bold text-yellow-600 mb-4">
        {t("app.payments.pendingTitle", "¡Pago pendiente!")}
      </h1>
      <p className="text-lg text-gray-700 mb-8">
        {t(
          "app.payments.pendingBody",
          "Tu pago está en proceso. Por favor, espera mientras confirmamos tu transacción. Si el pago no se completa en breve, intenta nuevamente o contacta al soporte."
        )}
      </p>
      <a
        href="/"
        className="px-6 py-3 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
      >
        {t("common.backToHome", "Volver al inicio")}
      </a>
      <p className="mt-4 text-sm text-gray-500">
        {t(
          "app.payments.supportHint",
          "Si necesitas ayuda, por favor contacta a nuestro equipo de soporte."
        )}
      </p>
    </main>
  );
}
